import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Legend
} from 'recharts';

const COLORS = ['#4ade80', '#22d3ee', '#fbbf24', '#ef4444', '#a78bfa', '#f472b6', '#34d399', '#fb923c'];

function formatDate(iso) {
  const d = new Date(iso);
  return d.getDate() + '/' + (d.getMonth() + 1);
}

function formatNumber(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(0) + 'K';
  return n.toString();
}

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload) return null;
  return (
    <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, padding: 12 }}>
      <p style={{ color: '#94a3b8', fontSize: 12, marginBottom: 8 }}>{label}</p>
      {payload.map((entry, i) => (
        <p key={i} style={{ color: entry.color, fontSize: 13 }}>
          {entry.name}: <span style={{ fontWeight: 'bold' }}>{entry.value?.toLocaleString('es-DO')}</span> bloques
        </p>
      ))}
    </div>
  );
};

export default function StatsChart({ history, serverFilter }) {
  if (!history || history.length === 0) {
    return (
      <div className="text-center py-8 text-mc-muted">
        <p className="text-2xl mb-2">📊</p>
        <p>No hay datos históricos disponibles</p>
      </div>
    );
  }

  const servers = [...new Set(history.map(h => h.server_name))];
  const filteredServers = serverFilter ? servers.filter(s => s === serverFilter) : servers;

  const dateMap = {};
  history.forEach(h => {
    if (serverFilter && h.server_name !== serverFilter) return;
    const dateKey = formatDate(h.date);
    if (!dateMap[dateKey]) dateMap[dateKey] = { date: dateKey };
    dateMap[dateKey][h.server_name] = h.mined_blocks;
  });

  const chartData = Object.values(dateMap);

  if (filteredServers.length > 1) {
    chartData.forEach(point => {
      point['Total'] = filteredServers.reduce((sum, s) => sum + (point[s] || 0), 0);
    });
  }

  const lines = filteredServers.length > 1
    ? ['Total', ...filteredServers]
    : filteredServers;

  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#2a2a4a" />
          <XAxis dataKey="date" stroke="#94a3b8" tick={{ fontSize: 11 }} />
          <YAxis stroke="#94a3b8" tick={{ fontSize: 11 }} tickFormatter={formatNumber} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12, color: '#94a3b8' }} />
          {lines.map((name, i) => (
            <Line
              key={name}
              type="monotone"
              dataKey={name}
              stroke={name === 'Total' ? '#ffffff' : COLORS[i % COLORS.length]}
              strokeWidth={name === 'Total' ? 2.5 : 1.5}
              dot={{ r: 3 }}
              activeDot={{ r: 5 }}
              connectNulls
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
